<template>
  <section class="proList">
    <com-tabs
      :list="proListInfo.obj.tabs"
      class="proList-tabs"
      :default-tab="activeTab"
      @change="changeTab"
    >
      <template v-slot:text="{ obj }">
        <div
          :class="{ activeTab: activeTab == obj.key }"
          class="proList-tabs-item"
        >
          {{ obj.name }}
        </div>
      </template>
    </com-tabs>
    <div v-loading.fullscreen.lock="loading" class="proList-content">
      <div>
        <div v-if="activeTab == 0">
          <span>学科分类：</span>
          <el-cascader
            v-model="categorys"
            :options="subjects"
            clearable
            @change="handleChange"
          />
          <span>快速查询：</span>
          <el-input v-model="requestParams.search" clearable />
          <el-button @click="init()">
            查询
          </el-button>
        </div>
        <div v-else />
        <div v-if="activeTab != 0">
          <el-button @click="handleShow">
            上传
          </el-button>
        </div>
      </div>
      <div>
        <div>
          <com-table
            :data="data1"
            :configs="proListInfo.obj.table1"
            stripe
            :is-route-dto="true"
            is-route-dto-str="name"
            @path="handleRouteDto1"
          >
            <template v-slot:operate="{ row }">
              <el-button
                type="text" @click="handleRouteDto(row)"
              >
                查看详情
              </el-button
              >
              /
              <a :href="linkStr(row)" :download="row.category_name">
                <span>下载</span>
              </a>
            </template>
          </com-table>
        </div>
      </div>
    </div>
    <div class="p-contianer">
      <el-pagination
        :current-page="requestParams.page"
        :page-sizes="pageSizes"
        :page-size.sync="requestParams.page_size"
        :total="total"
        :pager-count="5"
        class="p-bar"
        background
        layout="prev, pager, next, sizes, total, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </div>
    <com-list v-if="listShow" :subjects="subjects" @input="changeTab(1)" />
  </section>
</template>

<script>
import mock from '@/utils/mock'
import comTabs from '@/components/comTabs'
import comList from './details/comList.vue'
import comTable from '@/components/comTable'
export default {
  components: { comTabs, comList, comTable },
  data() {
    return {
      data1: [],
      subjects: null,
      activeTab: 0,
      proListInfo: mock.proList.proList.viewInfo,
      proListInit: mock.proList.proList.init,
      requestParams: {
        page: 1,
        page_size: 20,
        is_mine: 2,
        category_id: null,
        search: ''
      },
      categorys: [],
      loading: false,
      listShow: false,
      page: 1,
      page_size: 15,
      total: 0,
      pageSizes: [20, 30, 60, 100]

    }
  },
  computed: {},
  created() {
    this.loading = true
    this.init()
    this.initSubjects()
  },
  methods: {
    linkStr(v) {
      return `${process.env.VUE_APP_BASE_API}api/download_listingdetail?id=${v.id}`
    },
    handleShow() {
      this.listShow = true
    },
    handleChange(v) {
      this.requestParams.category_id = v[1]
    },
    async initSubjects() {
      this.subjects = await this.proListInit.subjects()
    },
    async init() {
      this.loading = true
      const res = await this.proListInit.data1(this.requestParams)
      this.data1 = res.data
      this.total = res.total
      this.loading = false
    },
    control(type, condition) {
      return mock.system.global.control[type](condition)
    },
    changeTab(v) {
      this.listShow = false
      this.activeTab = v
      if (v == 0) {
        this.requestParams.is_mine = 2
      } else {
        this.requestParams.is_mine = 1
      }
      this.init()
    },
    handleRouteDto1(x, v) {
      if (v == 'name') {
        this.$router.push({
          path: `/proList/details`,
          query: {
            id: x.id
          }
        })
      }
    },
    handleRouteDto(v) {
      this.$router.push({
        path: '/proList/details',
        query: {
          id: v.id
        }
      })
    },
    handleSizeChange(val) {
      this.requestParams.page_size = val
      this.init()
    },
    /**
     * 更改当前页数
     * @param {*} val
     */
    handleCurrentChange(val) {
      this.requestParams.page = val
      this.init()
    }
  }
}
</script>

<style scoped lang="scss">
.proList {
  // @include fun-layout(1);
  min-height: 400px;
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  width: $xr-medium-width;
  &-tabs {
    margin: 0 35px;
    &-item {
      text-align: center;
      @include fun-design(7);
      line-height: 40px;
      width: 60px;
      cursor: pointer;
    }
    .activeTab {
      @include fun-active();
    }
  }
  &-content {
    margin-top: 20px;
    padding: 20px;
    overflow: hidden;
    background-color: #fff;
    flex: 1;
    > div {
      &:nth-child(1) {
        display: flex;
        line-height: 40px;
        > div {
          &:nth-child(1) {
            flex: 1;
            display: flex;
            > span {
              margin-right: 10px;
              &:nth-child(3) {
                margin-left: 30px;
              }
            }
            > button {
              margin-left: 10px;
            }
          }
        }
      }
      &:nth-child(2) {
        margin-top: 12px;
        height: 100%;
        button {
          color: #666;
        }
      }
    }
  }
}
</style>
<style  lang="scss" scoped>
.proList-content /deep/ .el-input {
  width: 300px;
  height: 100%;
}
.proList-content /deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  width: 300px;
  height: 100%;
}
// .p-contianer {
//   position: relative;
//   background-color: white;
//   height: 44px;
//   border-top: 1px solid $xr-border-line-color ;
//   .p-bar {
//     float: right;
//     margin: 20px 100px 0 0;
//   }
// }
</style>
